import React, { useEffect, useState } from "react";
import { getDocs,collection } from "firebase/firestore";

import galleryImgae from "../../common/images/gallery.webp";
import Carousal from "../../common/Carousal";
import { db } from "../../Firebase/config";


export default function Gallery() {
  const controlCarousal = useState(true);
  useEffect(() => {
    fetchGallery()
  }, [])
  
  const [images, setImages] = useState([])
 
  async function fetchGallery(){
    const docRef = collection(db, "gallery");
    const docSnap = await getDocs(docRef);
    let images=[]
    docSnap.forEach(doc=>{
      images.push(doc.data())
    })
    console.log(images)
    setImages(images)
  }

  return (
    <div className="bg-white w-full flex h-auto px-2">
      <div className="w-full flex my-10 py-14 flex-wrap bg-white max-w-6xl 2xl:max-w-7xl mx-auto rounded-3xl">
        <div className="w-full justify-center mb-6">
          <h1 className="text-3xl text-black text-center mx-auto mb-1 font-bold">
            Gallery
          </h1>
          <div className=" flex w-full">
            <div className="flex mx-auto">
              <div className=" w-6 h-4 mr-1  rounded-full bg-blue-600"></div>
              <div className=" w-6 h-4 rounded-full  bg-green-700"></div>
            </div>
          </div>
        </div>
        ``
        <div className="mx-auto relative rounded-xl shadow-xl pb-8 md:pb-0 border flex flex-wrap w-full  ">
          <div className=" w-full z-10 max-w-2xl   rounded-xl md:w-3/5">
              <Carousal control={controlCarousal} images={images} />
          </div>
          <div className="w-full flex md:w-2/5 relative mt-12 md:my-auto">
            <div className="absolute  top-0 left-0 h-full flex flex-wrap w-full">
              <div className="flex sm:ml-4 flex-wrap ">
                <div className=" -mb-6 w-3 h-3 rounded-full pulse-anime3 bg-blue-700"></div>
              </div>
              <div className="flex flex-wrap ">
                <div className=" -mt-4 w-3 h-3 rounded-full pulse-anime1 bg-blue-600"></div>
              </div>
              <div className="flex ml-auto flex-wrap">
                <div className=" w-3 h-3 -mt-4 rounded-full pulse-anime1 bg-blue-600"></div>
              </div>
              <div className="flex flex-wrap">
                <div className=" w-3 h-3 rounded-full pulse-anime2 bg-blue-700"></div>
              </div>

              <div className="flex mt-auto  w-full flex-wrap">
                <div className="mx-auto -mb-8 flex">
                  <div className=" w-6 h-4 mr-1  rounded-full bg-blue-600"></div>
                  <div className=" w-6 h-4 rounded-full  bg-green-700"></div>
                </div>
              </div>

              {/* <div className="flex mt-auto flex-wrap ">
            <div className="-mt-4 -mb-6 w-6 h-6 rounded-full pulse-anime1 bg-blue-600"></div>
          </div> */}
            </div>
            <div className="text-lg sm:text-2xl px-2 mx-auto text-center z-10  font-bold w-full text-black">
              <div className="hidden sm:flex w-full">
                <img
                  src={galleryImgae}
                  alt=""
                  className=" object-contain w-full max-w-xs mx-auto opacity-90"
                ></img>
              </div>
              <span className="text-3xl sm:text-4xl md:text-5xl my-auto">
                A
              </span>{" "}
              picture is worth a thousand words
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
